var pug = require("!../../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (label, status) {pug_html = pug_html + "\u003Cdiv class=\"grid-cell\"\u003E\u003Cdiv" + (" class=\"statusicondisplay\""+pug.attr("aria-label", label, true, true)+" role=\"img\"") + "\u003E";
switch (status){
case 'Active':
pug_html = pug_html + "\u003Cdiv class=\"statusEnabled_icon\"\u003E\u003C\u002Fdiv\u003E";
  break;
case 'Deleted':
pug_html = pug_html + "\u003Cdiv class=\"statusDeleted_icon\"\u003E\u003C\u002Fdiv\u003E";
  break;
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"label" in locals_for_with?locals_for_with.label:typeof label!=="undefined"?label:undefined,"status" in locals_for_with?locals_for_with.status:typeof status!=="undefined"?status:undefined));;return pug_html;};
module.exports = template;